import sanityClient from '@sanity/client'


export default sanityClient({
  projectId: 'xkw15u60',
  dataset: 'production',
  token: 'skHkmHX3iSYqNeffbDc7jyBbwl0LLsr6EInWbjGMa9QH34KB7rf0Vn4bBz5RN0M8KJnRCObKpWPOQkrvLEyP9Dc2ar1APqoXmnWwH0zsbL6JoMgSVcVmN1psmW1PnVcj5Xa1qYdIDkoQZoRKv60efDNMs8BQWoQ2QvtXP9epOOBK2q5vgA6B', // or leave blank to be anonymous user
  useCdn: true // `false` if you want to ensure fresh data
})
